import React from 'react';
import { Header, Input } from 'semantic-ui-react';
import CompanyLogo from '../../../company/companyLogo';
import { KEYS } from '../../../../constnats/general';
import { useChartStoreChartActions, useChartStoreHeadingState, useChartCompanies } from '../../context';
import './chartHeading.css';

function ChartHeading() {
    const companies = useChartCompanies();
    const { heading, editingHeading } = useChartStoreHeadingState();
    const { setHeading, setEditingHeading } = useChartStoreChartActions();

    const handleSubHeadingSave = (e: React.KeyboardEvent) => {
        if (e.key === KEYS.ENTER) {
            setEditingHeading(false);
        }
    };

    const isMulti = companies.length > 1;

    return (
        <div className="ec-heading-wrapper">
            <div className={`ec-heading-row1${isMulti ? ' ec-heading-row1--multi' : ''}`} onDoubleClick={() => setEditingHeading(true)}>
                {isMulti ? (
                    companies.map((company, index) => (
                        <React.Fragment key={company.companyId}>
                            {index > 0 && <span className="ec-heading-vs">vs.</span>}
                            <span className="ec-heading-company-group">
                                <CompanyLogo companyId={company.companyId} className="ec-heading-logo" hideOnError />
                                <Header className="ec-heading-title" size="medium">
                                    {company.companyName}
                                </Header>
                            </span>
                        </React.Fragment>
                    ))
                ) : companies.length === 1 ? (
                    <>
                        <CompanyLogo companyId={companies[0].companyId} className="ec-heading-logo" />
                        <Header className="ec-heading-title" size="medium">
                            {companies[0].companyName}
                        </Header>
                    </>
                ) : null}
            </div>

            <div className="ec-heading-row2">
                {editingHeading ? (
                    <Input
                        fluid
                        value={heading}
                        onKeyDown={handleSubHeadingSave}
                        onChange={(_: unknown, data: { value: string }) => setHeading(data.value)}
                    />
                ) : (
                    <Header
                        className="chartHeading chart-subheading"
                        size="medium"
                        onDoubleClick={() => setEditingHeading(true)}
                    >
                        {heading}
                    </Header>
                )}
            </div>
        </div>
    );
}

export default React.memo(ChartHeading);
